
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10.623","height":"10.525"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_19425","data-name":"Path 19425","d":"M9.547.564a1.583 1.583 0 00-2.242 0L1.033 6.839a.352.352 0 00-.09.155L.116 9.976a.352.352 0 00.432.433l2.98-.825a.352.352 0 00.155-.09l6.275-6.275a1.585 1.585 0 000-2.239zM1.795 7.071l5.142-5.136 1.657 1.656-5.137 5.136zm-.331.664l1.324 1.324-1.83.507zm7.993-5.013l-.373.373-1.655-1.657.376-.372a.879.879 0 011.244 0l.412.412a.881.881 0 010 1.243zm0 0","fill":"#5a677d","stroke":"#5a677d","stroke-width":".2"}})])
          )
        }
      }
    